import Axios from "Services/Auth/AxiosInterceptors";

export const GetStates = async (page = 1, recordsPerPage = 100) => {
  const {
    data: { result },
  } = await Axios.get(`/state/state/get?page=${page}&perPage=${recordsPerPage}`);
  console.log("[GetStates][API_RESPONSE] - ", result);
  return result;
};
